import React, { useMemo } from 'react';

import {
  Flex, Center, Text, Stack, Box,
} from '@chakra-ui/react';

import BioCtrlLogo from 'components/svg/logo';
import AuthForm from 'containers/Auth';
import colors from 'theme/colors';

export default function Auth({ action }) {
  const Form = useMemo(() => AuthForm[action], [action]);

  return (
    <Flex
      bgImage={`url('/images/login-bg.png'), ${colors.gradient.primary}`}
      bgPosition="center"
      bgRepeat="no-repeat"
      bgSize="cover"
      flex={1}
      height="100vh">
      <Center
        flex={1}
        justifyContent="space-between"
        px={100}>
        <Stack spacing={10}>
          <BioCtrlLogo
            width={280}
            height={70}
            mode="light"
          />
          <Box>
            <Text
              maxW={500}
              color="white.default"
              variant="5xLargeBold">
              Controle e gestão
            </Text>
            <Text
              maxW={500}
              color="white.default"
              variant="5xLargeRegular">
              no transporte de materiais biológicos.
            </Text>
          </Box>
        </Stack>
        <Flex
          borderRadius={8}
          p={10}
          shadow={1}
          bg="white.default"
          width={380}>
          <Form />
        </Flex>
      </Center>
    </Flex>
  );
}
